<div class="grid__col-12 guts-p-v-0">
  <dgx-tab-navigation [tabList]="tabList"></dgx-tab-navigation>
</div>
